import React from "react";
import { Container, Col, Row, Form, FormGroup, Input, Button} from "reactstrap";


class YourView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      text: "",
      feedback:false
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    const scriptURL =
      `https://script.google.com/macros/s/AKfycbz4PLKF0PEdD_KwdmTyx_7v0ZBbvKLH_-5FDLIYRc0oTW_bT7LS/exec?data1=${this.state.text}`;
    if (this.state.text!==""){
      this.setState({
        feedback: true
      });
    fetch(scriptURL)
      .then(response => console.log("Success!", response))
      .catch(error => console.error("Error!", error.message));
    }
  };

  handleChange = e => {
    this.setState({
      text: e.target.value
    });
  };

  render() {
    let feedback=this.state.feedback?<p className="whiteback text-left feedbackpad">Thank you for your feedback. Follow <a href="https://twitter.com/AJLabs" target="_blank" rel="noopener noreferrer">AJLabs on Twitter</a> for more information.</p>:<p>&nbsp;</p>
    return (
      <div className="fullscreen yourview">
        <Container fluid className="fullscreen">
          <Row className="justify-content-center align-items-center">
            <Col xl="7" lg="8" md="9" xs="12">
              <p className="display-4 text-center text-white">
              What do you think of Trump's new plan?
              </p>
              <Form style={{display:this.state.feedback?"none":"block"}} onSubmit={this.handleSubmit} name="googlesheet">
                <FormGroup>
                  <Input style={{height:"150px"}}
                    type="textarea"
                    value={this.state.text}
                    onChange={this.handleChange}
                  />
                  <br/>
                  <section className="center">
                  <Button type="submit"  className="center">
                  Submit</Button>
                  </section>
                </FormGroup>
              </Form>
              {feedback}
            </Col>
          </Row>
        </Container>
        <Container fluid>
        <Container className="relatedsection">
        <h4 className="text-white text-left">ALSO READ</h4>
        <p className="grayline"></p>
          <Row className="justify-content-center align-items-center">
          <Col className="relatedbox" xl="4" lg="4" md="4" xs="12">
            <h5 className="text-white">Podcast: A 'Swiss cheese state', a 'peace' plan and a Palestinian POV.</h5>
          <a href="https://www.aljazeera.com/podcasts/thetake/2020/02/swiss-cheese-state-peace-plan-palestinian-pov-200212171649149.html" target="_blank" rel="noopener noreferrer"><img src='./jpg/related/thetake.jpg' className="fluid" alt=""/></a>
          </Col>
          <Col className="relatedbox" xl="4" lg="4" md="4" xs="12">
            <h5 className="text-white">Palestine Remix: Explore the full story of Palestine.</h5>
          <a href="https://interactive.aljazeera.com/aje/palestineremix/" target="_blank" rel="noopener noreferrer"><img src='./jpg/related/related0.jpg' className="fluid" alt=""/></a>
          </Col>
          <Col className="relatedbox" xl="4" lg="4" md="4" xs="12">
          <h5 className="text-white">Israel's settlements: Over 50 years of land theft explained</h5>
          <a href="https://interactive.aljazeera.com/aje/2017/50-years-illegal-settlements/index.html" target="_blank" rel="noopener noreferrer"><img src='./jpg/related/related2.jpg' className="fluid" alt=""/></a>
          </Col>
          </Row>
          <br/>
          <Row className="justify-content-center align-items-center">
          <Col className="relatedbox" xl="4" lg="4" md="4" xs="12">
            <h5 className="text-white">How world leaders react to Trump's Middle East plan</h5>
          <a href="https://www.aljazeera.com/news/2020/01/world-reaction-trump-middle-east-plan-200128173439574.html" target="_blank" rel="noopener noreferrer"><img src='./jpg/related/world.jpg' className="fluid" alt=""/></a>
          </Col>
          <Col className="relatedbox" xl="4" lg="4" md="4" xs="12">
            <h5 className="text-white">Interactive: Who was behind the Balfour Declaration?</h5>
          <a href="https://interactive.aljazeera.com/aje/2017/behind-balfour/index.html" target="_blank" rel="noopener noreferrer"><img src='./jpg/related/related1.jpg' className="fluid" alt=""/></a>
          </Col>
          <Col className="relatedbox" xl="4" lg="4" md="4" xs="12">
          <h5 className="text-white">Does Trump's US-Israeli plan make Middle East peace impossible?</h5>
          <a href="https://www.aljazeera.com/programmes/the-bottom-line/2020/01/trump-israeli-plan-middle-east-peace-impossible-200128220759641.html" target="_blank" rel="noopener noreferrer"><img src='./jpg/related/bottomline.jpg' className="fluid" alt=""/></a>
          </Col>
          </Row>
          {/* <p className="text-white" id="methodology"><strong>Methodology</strong></p>
          <p className="text-white">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p> */}
<br/>
          </Container>
          </Container>
      </div>
    );
  }
}

export default YourView;